export default __webpack_public_path__ + "static/media/banner-standards-mobile.1369600e.png";